import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";

import api from "../../services/api";

import * as S from "./styled";

import Template from "../../template";
import InputMask from "react-input-mask";

function Corretores() {
  const [loading, setLoading] = useState(true);

  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  const [redacoes, setRedacoes] = useState([]);
  const [corretores, setCorretores] = useState([]);
  const [temas, setTemas] = useState([]);
  
  // Estados para filtros de busca
  const [buscaCorretor, setBuscaCorretor] = useState("");
  const [buscaTema, setBuscaTema] = useState("");
  
  // Estados para dropdowns dinâmicos
  const [showDropdownCorretor, setShowDropdownCorretor] = useState(false);
  const [showDropdownTema, setShowDropdownTema] = useState(false);
  
  // Estados para filtros selecionados
  const [corretorSelecionado, setCorretorSelecionado] = useState("");
  const [temaSelecionado, setTemaSelecionado] = useState("");
  
  // Estados para paginação
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina, setItensPorPagina] = useState(50);
  const [itensPorPaginaDropdownAberto, setItensPorPaginaDropdownAberto] = useState(false);

  /* formatar data para o padrão BR */
  const formatarData = (dataTurma) => {
    if (dataTurma) {
      let dataFinal = dataTurma.split("T");

      return dataFinal[0].split("-").reverse().join("/");
    }
  };

  // Filtros dinâmicos
  const corretoresFiltrados = buscaCorretor
    ? corretores.filter(corretor => 
        corretor.name.toLowerCase().includes(buscaCorretor.toLowerCase())
      )
    : corretores.sort((a, b) => a.name.localeCompare(b.name));

  const temasFiltrados = buscaTema
    ? temas.filter(tema => 
        tema.nome.toLowerCase().includes(buscaTema.toLowerCase())
      )
    : temas.sort((a, b) => a.nome.localeCompare(b.nome));

  // Filtro principal de redações (apenas filtros frontend - data é filtrada no backend)
  const redacoesFiltradas = redacoes.filter(redacao => {
    const filtroCorretor = !corretorSelecionado || redacao.corretor === corretorSelecionado;
    const filtroTema = !temaSelecionado || redacao.nome_redacao === temaSelecionado;
    
    return filtroCorretor && filtroTema;
  });

  // Paginação
  const totalPaginas = Math.ceil(redacoesFiltradas.length / itensPorPagina);
  const indiceInicial = (paginaAtual - 1) * itensPorPagina;
  const indiceFinal = indiceInicial + itensPorPagina;
  const redacoesPaginadas = redacoesFiltradas.slice(indiceInicial, indiceFinal);

  const getRedacoes = async () => {
    setLoading(true);
    const dataCorretor = {
      id: corretorSelecionado ? corretores.find(c => c.name === corretorSelecionado)?.id : null,
      dataInicio,
      dataFim,
      tema: temaSelecionado ? temas.find(t => t.nome === temaSelecionado)?.id : null
    };

    try {
      let response = await api.post(`/getRedacoesCorretores`, dataCorretor);
      setRedacoes(response.data);
    } catch (err) {
      console.error('Erro ao carregar redações:', err);
    } finally {
      setLoading(false);
    }
  };

  const getCorretores = async () => {
    setLoading(true);
    try {
      let response = await api.get(`/getCorretores`);
      setCorretores(response.data);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const getTemas = async () => {
    setLoading(true);
    try {
      let response = await api.get(`/pegarTemasGeral`);
      setTemas(response.data);
    } catch (err) {
      console.error('Erro ao carregar temas:', err);
    } finally {
      setLoading(false);
    }
  };

  // Funções de seleção
  const selecionarCorretor = (corretor) => {
    setCorretorSelecionado(corretor.name);
    setBuscaCorretor("");
    setShowDropdownCorretor(false);
    setPaginaAtual(1);
  };

  const selecionarTema = (tema) => {
    setTemaSelecionado(tema.nome);
    setBuscaTema("");
    setShowDropdownTema(false);
    setPaginaAtual(1);
  };

  // Função para limpar filtros
  const limparFiltros = () => {
    setBuscaCorretor("");
    setBuscaTema("");
    setCorretorSelecionado("");
    setTemaSelecionado("");
    setDataInicio("");
    setDataFim("");
    setShowDropdownCorretor(false);
    setShowDropdownTema(false);
    setItensPorPaginaDropdownAberto(false);
    setPaginaAtual(1);
  };

  // Funções de paginação
  const irParaPagina = (pagina) => {
    setPaginaAtual(pagina);
  };

  const paginaAnterior = () => {
    if (paginaAtual > 1) {
      setPaginaAtual(paginaAtual - 1);
    }
  };

  const proximaPagina = () => {
    if (paginaAtual < totalPaginas) {
      setPaginaAtual(paginaAtual + 1);
    }
  };

  // Controle de clique fora dos dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-container')) {
        setShowDropdownCorretor(false);
        setShowDropdownTema(false);
        setItensPorPaginaDropdownAberto(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getTemas();
    setLoading(true);
    getCorretores();
    getRedacoes();
  }, []);

  // Atualizar redações quando filtros de data mudarem
  useEffect(() => {
    if (corretores.length > 0 && temas.length > 0) {
      getRedacoes();
    }
  }, [dataInicio, dataFim, corretorSelecionado, temaSelecionado]);

  return (
    <Template>
      <S.MainWrapper>
        <Container fluid>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                <Row>
                  <Col>
                    <div className="alert alert-primary" role="alert">
                      <strong>Corretores - Informações</strong>
                    </div>
                  </Col>
                </Row>

                {/* Seção de Filtros */}
                <Row>
                  <Col>
                    <div className="card shadow-sm mb-4">
                      <div className="card-header bg-light text-dark d-flex justify-content-between align-items-center">

                        <h5 className="mb-0">
                          <i className="fas fa-filter mr-2"></i>
                          Filtros de Busca
                        </h5>
                        <div>
                          <button 
                            className="btn btn-light btn-sm mr-2" 
                            onClick={limparFiltros}
                            title="Limpar todos os filtros"
                          >
                            <i className="fas fa-eraser mr-1"></i>
                            Limpar
                          </button>
                          <button 
                            className="btn btn-success btn-sm" 
                            onClick={getRedacoes}
                            title="Aplicar filtros"
                          >
                            <i className="fas fa-search mr-1"></i>
                            Buscar
                          </button>
                        </div>
                      </div>
                      <div className="card-body" style={{ overflow: 'visible' }}>
                        <Row>
                          {/* Controle de Itens por Página */}
                          <Col xs={12} md={2} className="mb-3">
                            <Form.Group className="dropdown-container" style={{ position: 'relative' }}>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-list text-primary mr-1"></i>
                                Itens por Página
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-list"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  value={`${itensPorPagina} por página`}
                                  onClick={() => {
                                    setItensPorPaginaDropdownAberto(!itensPorPaginaDropdownAberto);
                                    setShowDropdownCorretor(false);
                                    setShowDropdownTema(false);
                                  }}
                                  readOnly
                                  className="form-control-lg"
                                  style={{ cursor: 'pointer', backgroundColor: 'white' }}
                                />
                              </InputGroup>
                              {itensPorPaginaDropdownAberto && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.25rem 0.25rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {[25, 50, 100, 200].map((valor) => (
                                    <div
                                      key={valor}
                                      onClick={() => {
                                        setItensPorPagina(valor);
                                        setPaginaAtual(1);
                                        setItensPorPaginaDropdownAberto(false);
                                      }}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        backgroundColor: itensPorPagina === valor ? '#007bff' : 'white',
                                        color: itensPorPagina === valor ? 'white' : 'black'
                                      }}
                                      onMouseEnter={(e) => {
                                        if (itensPorPagina !== valor) {
                                          e.target.style.backgroundColor = '#f8f9fa';
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (itensPorPagina !== valor) {
                                          e.target.style.backgroundColor = 'white';
                                        }
                                      }}
                                    >
                                      {valor} por página
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Filtro por Corretor com busca */}
                          <Col xs={12} md={2} className="mb-3">
                            <Form.Group className="dropdown-container">
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-user-check text-primary mr-1"></i>
                                Corretor
                              </Form.Label>
                              <div style={{ position: 'relative' }}>
                                <InputGroup className="mb-2">
                                  <InputGroup.Prepend>
                                    <InputGroup.Text>
                                      <i className="fas fa-search"></i>
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                  <Form.Control
                                    type="text"
                                    placeholder="Buscar corretor..."
                                    value={buscaCorretor}
                                    onChange={(e) => {
                                       setBuscaCorretor(e.target.value);
                                       setShowDropdownCorretor(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setShowDropdownTema(false);
                                     }}
                                     onFocus={() => {
                                       setShowDropdownCorretor(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setShowDropdownTema(false);
                                     }}
                                     onBlur={() => setTimeout(() => setShowDropdownCorretor(false), 200)}
                                     className="form-control-lg"
                                  />
                                </InputGroup>
                                {corretorSelecionado && (
                                  <div className="mt-1">
                                    <span className="badge badge-warning">
                                      {corretorSelecionado}
                                      <button 
                                        type="button" 
                                        className="btn btn-sm btn-link text-white p-0 ml-2" 
                                        style={{ fontSize: '0.7em' }}
                                        onClick={() => {
                                          setCorretorSelecionado("");
                                          setPaginaAtual(1);
                                        }}
                                      >
                                        ×
                                      </button>
                                    </span>
                                  </div>
                                )}
                                {showDropdownCorretor && corretoresFiltrados.length > 0 && (
                                  <div 
                                    style={{
                                      position: 'absolute',
                                      top: '100%',
                                      left: 0,
                                      right: 0,
                                      backgroundColor: 'white',
                                      border: '1px solid #ced4da',
                                      borderTop: 'none',
                                      borderRadius: '0 0 0.375rem 0.375rem',
                                      maxHeight: '400px',
                                      overflowY: 'auto',
                                      zIndex: 9999,
                                      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                                      marginTop: '-1px'
                                    }}
                                  >
                                    {corretoresFiltrados.map((corretor, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          padding: '8px 12px',
                                          cursor: 'pointer',
                                          borderBottom: index < corretoresFiltrados.length - 1 ? '1px solid #eee' : 'none'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                        onClick={() => selecionarCorretor(corretor)}
                                      >
                                        {corretor.name}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </Form.Group>
                          </Col>

                          {/* Filtro por Tema com busca */}
                          <Col xs={12} md={2} className="mb-3">
                            <Form.Group className="dropdown-container">
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-book text-primary mr-1"></i>
                                Tema
                              </Form.Label>
                              <div style={{ position: 'relative' }}>
                                <InputGroup className="mb-2">
                                  <InputGroup.Prepend>
                                    <InputGroup.Text>
                                      <i className="fas fa-search"></i>
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                  <Form.Control
                                    type="text"
                                    placeholder="Buscar tema..."
                                    value={buscaTema}
                                    onChange={(e) => {
                                       setBuscaTema(e.target.value);
                                       setShowDropdownTema(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setShowDropdownCorretor(false);
                                     }}
                                     onFocus={() => {
                                       setShowDropdownTema(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setShowDropdownCorretor(false);
                                     }}
                                     onBlur={() => setTimeout(() => setShowDropdownTema(false), 200)}
                                     className="form-control-lg"
                                  />
                                </InputGroup>
                                {temaSelecionado && (
                                  <div className="mt-1">
                                    <span className="badge badge-info">
                                      {temaSelecionado}
                                      <button 
                                        type="button" 
                                        className="btn btn-sm btn-link text-white p-0 ml-2" 
                                        style={{ fontSize: '0.7em' }}
                                        onClick={() => {
                                          setTemaSelecionado("");
                                          setPaginaAtual(1);
                                        }}
                                      >
                                        ×
                                      </button>
                                    </span>
                                  </div>
                                )}
                                {showDropdownTema && temasFiltrados.length > 0 && (
                                  <div 
                                    style={{
                                      position: 'absolute',
                                      top: '100%',
                                      left: 0,
                                      right: 0,
                                      backgroundColor: 'white',
                                      border: '1px solid #ced4da',
                                      borderTop: 'none',
                                      borderRadius: '0 0 0.375rem 0.375rem',
                                      maxHeight: '400px',
                                      overflowY: 'auto',
                                      zIndex: 9999,
                                      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                                      marginTop: '-1px'
                                    }}
                                  >
                                    {temasFiltrados.map((tema, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          padding: '8px 12px',
                                          cursor: 'pointer',
                                          borderBottom: index < temasFiltrados.length - 1 ? '1px solid #eee' : 'none'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                        onClick={() => selecionarTema(tema)}
                                      >
                                        {tema.nome}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </Form.Group>
                          </Col>

                          {/* Filtro por Data de Início */}
                          <Col xs={12} md={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-calendar-alt text-primary mr-1"></i>
                                Data de Início
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  className="form-control-lg"
                                  value={dataInicio}
                                  onChange={(e) => setDataInicio(e.target.value)}
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>

                          {/* Filtro por Data de Fim */}
                          <Col xs={12} md={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-calendar-alt text-primary mr-1"></i>
                                Data de Fim
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  className="form-control-lg"
                                  value={dataFim}
                                  onChange={(e) => setDataFim(e.target.value)}
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
                {loading ? (
                  <>
                    <Col className="text-center">
                      <div className="shadow p-3 mb-4 bg-white rounded fdark flex-c">
                        <div>
                          <div className="spinner-grow text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div
                            className="spinner-grow text-secondary"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div className="spinner-grow text-success" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div className="spinner-grow text-danger" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div className="spinner-grow text-warning" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div className="spinner-grow text-info" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                        <div>
                          <strong>CARREGANDO</strong>
                        </div>
                      </div>
                    </Col>
                  </>
                ) : (
                  <>
                {/* Seção da Tabela */}
                <Row>
                  <Col>
                    <div className="card shadow-sm">
                      <div className="card-header bg-light text-dark d-flex justify-content-between align-items-center">
                        <h5 className="mb-0">
                          <i className="fas fa-table mr-2"></i>
                          Redações para Correção
                        </h5>
                        <span className="badge badge-light">
                          {redacoesFiltradas.length} redação(ões) encontrada(s)
                        </span>
                      </div>
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-bordered table-striped mb-0">
                            <thead className="thead-light">
                              <tr>
                                <th className="text-center" style={{ width: '40%' }}>
                                  <i className="fas fa-book mr-1"></i>
                                  Tema
                                </th>
                                <th className="text-center" style={{ width: '20%' }}>
                                  <i className="fas fa-user-check mr-1"></i>
                                  Corretor
                                </th>
                                <th className="text-center" style={{ width: '15%' }}>
                                  <i className="fas fa-graduation-cap mr-1"></i>
                                  Aula/Bônus
                                </th>
                                <th className="text-center" style={{ width: '15%' }}>
                                  <i className="fas fa-calendar mr-1"></i>
                                  Data
                                </th>
                                <th className="text-center" style={{ width: '10%' }}>
                                  <i className="fas fa-cogs mr-1"></i>
                                  Ações
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {redacoesPaginadas.length > 0 ? (
                                redacoesPaginadas.map((redacao, idx) => (
                                  <tr key={idx} className="align-middle">
                                    <td className="text-left">
                                      <div className="d-flex align-items-center">
                                        <i className="fas fa-file-alt text-primary mr-2"></i>
                                        <span className="font-weight-medium">{redacao.nome_redacao}</span>
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <span className="badge badge-info px-3 py-2">
                                        {redacao.corretor}
                                      </span>
                                    </td>
                                    <td className="text-center">
                                      <span className="badge badge-secondary px-3 py-2">
                                        Aula {redacao.aula}
                                      </span>
                                    </td>
                                    <td className="text-center">
                                      <small className="text-muted">
                                        <i className="fas fa-clock mr-1"></i>
                                        {formatarData(redacao.updated_at)}
                                      </small>
                                    </td>
                                    <td className="text-center">
                                      <Link
                                        to={`/corrigir/redacao/${redacao.id}`}
                                        className="btn btn-success btn-sm"
                                        title="Ver correção"
                                      >
                                        <i className="fas fa-eye mr-1"></i>
                                        Ver Correção
                                      </Link>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center py-4">
                                    <div className="text-muted">
                                      <i className="fas fa-search fa-2x mb-3"></i>
                                      <p className="mb-0">Nenhuma redação encontrada com os filtros aplicados.</p>
                                      <small>Tente ajustar os filtros ou limpar a busca.</small>
                                    </div>
                                  </td>
                                </tr>
                              )}
                              {redacoesPaginadas.length > 0 && (
                                <tr className="table-info">
                                  <td colSpan={4} className="font-weight-bold">Total de Correções no Período</td>
                                  <td className="text-center font-weight-bold">
                                    <span className="badge badge-primary px-3 py-2">
                                      {redacoesFiltradas.length}
                                    </span>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Seção de Paginação */}
                {redacoesFiltradas.length > 0 && totalPaginas > 1 && (
                  <Row className="mt-4">
                    <Col>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="text-muted">
                          Mostrando {indiceInicial + 1} a {Math.min(indiceFinal, redacoesFiltradas.length)} de {redacoesFiltradas.length} registros
                        </div>
                        <nav>
                          <ul className="pagination mb-0">
                            <li className={`page-item ${paginaAtual === 1 ? 'disabled' : ''}`}>
                              <button 
                                className="page-link" 
                                onClick={paginaAnterior}
                                disabled={paginaAtual === 1}
                              >
                                <i className="fas fa-chevron-left"></i>
                              </button>
                            </li>
                            
                            {Array.from({ length: Math.min(5, totalPaginas) }, (_, i) => {
                              let pageNumber;
                              if (totalPaginas <= 5) {
                                pageNumber = i + 1;
                              } else if (paginaAtual <= 3) {
                                pageNumber = i + 1;
                              } else if (paginaAtual >= totalPaginas - 2) {
                                pageNumber = totalPaginas - 4 + i;
                              } else {
                                pageNumber = paginaAtual - 2 + i;
                              }
                              
                              return (
                                <li key={pageNumber} className={`page-item ${paginaAtual === pageNumber ? 'active' : ''}`}>
                                  <button 
                                    className="page-link" 
                                    onClick={() => irParaPagina(pageNumber)}
                                  >
                                    {pageNumber}
                                  </button>
                                </li>
                              );
                            })}
                            
                            <li className={`page-item ${paginaAtual === totalPaginas ? 'disabled' : ''}`}>
                              <button 
                                className="page-link" 
                                onClick={proximaPagina}
                                disabled={paginaAtual === totalPaginas}
                              >
                                <i className="fas fa-chevron-right"></i>
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </Col>
                  </Row>
                )}
                  </>
                )}
              </S.MainContent>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>
    </Template>
  );
}

export default Corretores;
